var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"cn-color-select",class:{
    'cn-color-select--large': _vm.large,
  }},_vm._l((_vm.items),function(item,i){return _c(_vm.clickable ? 'UiLink' : 'button',{key:i,tag:"component",staticClass:"cn-color-select__color",class:[
      { 'cn-color-select__color--active': _setup.activeColor === item.color },
    ],style:(`--ab-canyon-color-select-color-bg: ${item.color}`),attrs:{"to":item.slug && item.slug},on:{"click":function($event){return _setup.setColor(item.color, i)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }